import React, { Component } from 'react';
import propTypes from 'prop-types';
import { MainContent, Content } from 'client/components/App';
import { Helmet } from 'react-helmet';
import { AppSparklinesBar } from 'client/components/Helpers/Sparklines';
import ConnectedQRTDWidgetStatistic from 'client/components/QRTD/ConnectedQRTDWidgetStatistic';
import ConnectedQRTDOptionsForm from 'client/components/QRTD/ConnectedQRTDOptionsForm';
import InstanceWidgetPlan from 'client/components/Instance/components/InstanceWidgetPlan';
import InstanceWidgetControls from 'client/components/Instance/components/InstanceWidgetControls';
import InstanceDashboard from 'client/components/Instance/InstanceDashboard';
import ConnectedQRTDCodeCreator from 'client/components/QRTD/ConnectedQRTDCodeCreator';
import { connect } from 'react-redux';
import { instanceSettingsDisabled } from 'client/redux/instance/instanceHelpers';
import _ from 'lodash';
import { push } from 'connected-react-router';
import InstanceParentAlert from 'client/components/Instance/components/InstanceParentAlert';

class ConnectedQRTDModule extends Component {

  static propTypes = {
    instanceId: propTypes.string.isRequired,
    tab: propTypes.string.isRequired,
  };

  handleSelectTab = newTab => {
    if (newTab === this.props.tab) return;
    const instanceId = this.props.instanceId;
    this.props.push(`/instance/qrtd/${instanceId}/${newTab}`);
  };

  render () {
    const { instanceId } = this.props;
    return (
      <Content>
        <Helmet>
          <title>QR Codes → TOPdesk Incidents</title>
        </Helmet>
        <MainContent>
          <InstanceParentAlert />
          <div className="row">
            <div className="col-xs-12 col-md-6 col-lg-3">
              <ConnectedQRTDWidgetStatistic
                title="Actions per month"
                id={instanceId}
                statistic="logSummer"
                query={{duration: 'month', limit: 7}}
                Component={AppSparklinesBar}
              />
            </div>
            <div className="col-xs-12 col-md-6 col-lg-3">
              <InstanceWidgetPlan
                id={instanceId}
                shouldReadInstance={false}
              />
            </div>
            <div className="col-xs-12 col-md-6 col-lg-3">
              <InstanceWidgetControls
                id={instanceId}
                shouldReadInstance={false}
              />
            </div>
          </div>
          <InstanceDashboard
            id={this.props.instanceId}
            tab={this.props.tab}
            OptionsFormComponent={ConnectedQRTDOptionsForm}
            onSelectTab={this.handleSelectTab}
            endpointOrder={['topdesk']}
            tabOrder={[
              {name: 'auth'},
              {name: 'options'},
              {name: 'qrCodeCreator', displayName: 'Create QR codes', icon: 'mdi-group'},
              {name: 'events'},
            ]}
            tabComponents={{
              qrCodeCreator: props => <ConnectedQRTDCodeCreator
                {...props} 
                disabled={instanceSettingsDisabled(_.get(props, 'instance.status'))}
              />,
            }}
          />
        </MainContent>
      </Content>
    );
  }

}

const actions = {
  push,
};

export default connect(null, actions)(ConnectedQRTDModule);
